import { useQuery } from 'data-fetching-client';
import { GET_CURRENCIES, GET_IN_APP_CURRENCIES, GET_PUBLIC_CURRENCIES } from 'pricing-pages-api/currency/queries';
import { CURRENCY } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
import { useGetCurrencyStore, useSetCurrencyStore } from '../context/CurrencyContext';
import { useSetOneGlobalLoadingState } from '../context/GlobalLoadingStateContext';
const UseSetLoadingCurrencyComplete = () => {
  const loadingCompletedCallback = useSetOneGlobalLoadingState('Currencies');
  const setStore = useSetCurrencyStore();
  const handleCurrencyFetchCompleted = ({
    currencies
  }) => {
    setStore(currencies);
    loadingCompletedCallback();
  };
  return handleCurrencyFetchCompleted;
};
export const useInAppCurrencies = () => {
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();
  const {
    data,
    error,
    loading
  } = useQuery(GET_IN_APP_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY
    },
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const usePublicCurrencies = () => {
  const browserLocale = getPreferredLanguage().toLowerCase() || 'en-us';
  const preferredCountryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  const handleCurrencyFetchCompleted = UseSetLoadingCurrencyComplete();
  const {
    data,
    error,
    loading
  } = useQuery(GET_PUBLIC_CURRENCIES, {
    variables: {
      earlyRequestName: CURRENCY,
      browserLocale,
      preferredCountryCode
    },
    onCompleted: handleCurrencyFetchCompleted
  });
  const currencyData = data && data.currencies;
  return {
    currencyData,
    error,
    loading
  };
};
export const usePricingPageCurrencies = ({
  isAppAuth
}) => {
  const queryHookToUse = isAppAuth ? useInAppCurrencies : usePublicCurrencies;
  return queryHookToUse();
};
export const useDisplayedCurrencyCode = () => {
  const currencyCode = useGetCurrencyStore(store => store.displayedCurrencyCode);
  return currencyCode;
};
export const useCurrencyCodeUnitToDisplay = () => {
  const currencyCodeUnit = useGetCurrencyStore(store => store.currencyCodeUnit);
  const showCurrencyCodeUnit = useGetCurrencyStore(store => store.showCurrencyCodeUnit);
  return showCurrencyCodeUnit ? currencyCodeUnit : undefined;
};
export const useAvailableCurrencyCodes = () => {
  const availableCurrencyCodes = useGetCurrencyStore(store => store.availableCurrencyCodes);
  return availableCurrencyCodes;
};

//  countryCode?: string | null | undefined;
export const useCountryCode = () => {
  const countryCode = useGetCurrencyStore(store => store.countryCode);
  return countryCode;
};

// ******************* Upgrade Page in PPUI Request ***********************
/**
 * @temporary used to support the version of the Upgrade Page App that lives in PPUI
 * This should be removed once the upgrade page has been extracted from PPUI
 * @expiration 2025-05-09
 * @deprecated
 */
export const useCurrencies = () => {
  const {
    data,
    error,
    loading
  } = useQuery(GET_CURRENCIES);
  return {
    currencyData: data === null || data === void 0 ? void 0 : data.currencies,
    error,
    loading
  };
};